import React from "react";
import LocationBanner from "components/locationBanner/index";
import AcadmicInstruction from "components/reusableComponents/AcadmicInstruction";
import Benifits from "components/reusableComponents/Benifits";
import {
  BefitisData,
  VariousTranslationData,
} from "components/reusableComponents/config";
import SpeceficTranslation from "components/LocationReusableComp/speceficTranslation";
import TechnicalDocument from "components/reusableComponents/technicalDocument";
import VariousTranslation from "components/reusableComponents/VariousTranslation";
import TrustedTranslation from "components/LocationReusableComp/trustedtranslation";
import CommonUseCases from "components/reusableComponents/CommonUseCases";
import Reviews from "components/homepage/reviews";
import WhatChooseUs from "components/homepage/whyChooseUs";
import LocalizationMidText from "components/reusableComponents/localizationMidText/index";
import WhatsAppComp from "components/reusableComponents/whatsappComp";
import TranslateAgency from "components/homepage/translateAgency";

function TechnicalTranslation() {
  return (
    <>
      <LocationBanner
        title="Technical Translation Services"
        backgroundCol="bg-[#00173A]"
        content="Technical translation services cover a broad range of language conversion and adaptation activities. Tomedes is an expert and experienced technical translation agency, responsible for technical document translation across diverse professional and industrial sectors. Our worldwide network of linguists translate scientific and technical documentation in more than 950+ language pairs."
        formOrangeHead="Get in touch "
        formWhiteHead="with our Technical Translation Company"
      />
      {/* <AcadmicInstruction
        BackgroundCol="bg-darkBlue"
        colorHead="Trusted"
        head="Technical Translation Services"
        secondHead="By
      Scientific and Academic Institutions"
        content="Tomedes is trusted by Fortune 500 companies and small businesses worldwide, such as scientific and academic
      institutions. Join 95,000+ satisfied customers today."
      /> */}
      <TranslateAgency
        head="Technical Translation Services"
        colorHead="Trusted"
        lastHeadText="By
      Scientific and Academic Institutions"
        content="Tomedes is trusted by Fortune 500 companies and small businesses worldwide, such as scientific and academic
      institutions. Join 95,000+ satisfied customers today."
      />
      <LocalizationMidText
        orangeMidText="technical"
        content="experts for our technical translation services
      assist brands and organizations in their global objectives,
      providing scalable and guaranteed solutions that are delivered
      on-time by our team of professional experts."
      />
      <SpeceficTranslation
        backgroundCol="bg-technical-banner"
        link=" "
        FirstWhite=""
        padding="md:py-32"
        ColorHead="Technical"
        headColor="text-lightBlue"
        SecondWhite="Document Translation
        by Experts"
        Content="Our technical experts translate your scientific, technical and academic documents for acceptance in journals,
conferences, and fellowships. At Tomedes, only technical experts can do technical translations, which is why
we choose industry experts in your discipline."
      />
      <Benifits BefitisData={BefitisData} />
      <TechnicalDocument />

      <SpeceficTranslation
        FirstOrange="Technical"
        SecondWhite="Translation Services for Applied and
        Industrial Sciences"
        headColor="text-orange"
        Content="Tomedes performs translation scientifically and methodologically, approaching technical document translation as an application of scientific principles and scientific methods. We carry out our technical translations remotely, serving thousands of clients across the world in mathematics and technology, academia and industry. We have executed technical translations in virtually every business domain imaginable, including the many vertical sectors that comprise applied and industrial sciences. Our expert linguists, knowledgeable in more than 950+ language pairs, are also trained in a broad range of scientific disciplines."
        backgroundCol="bg-midBlue"
        link=" "
      />
      <div className="bg-cover bg-no-repeat bg-center w-full h-full">
        <img
          src="https://tomedes.gumlet.io/frontend/images/services-new/applied_industrial_bg_technical.webp"
          alt=""
          className="w-full md:block hidden"
        />
      </div>
      <VariousTranslation
        ftitle="Technical"
        para="With thousands of trained linguists in our network, we can hand-pick the technical translation team that are
      knowledgeable about the languages and disciplines required."
        title="Translation for Various Fields"
        data={VariousTranslationData}
      />
      <TrustedTranslation
        backgroundCol="bg-midBlue"
        FirstWhite=""
        headColor="text-orange"
        ColorHead="Technical"
        SecondWhite="document translation services"
        Content="In our globalized world, translating technical documents into various languages is essential for diverse scientific and engineering disciplines, for scholarly pursuits as well as industrial ones. Tomedes has assembled a worldwide team of thousands of skilled linguists, fluent in over 120 languages and 950+ language pairs in virtually every business and academic domain. Our specialty is technical translation of diverse documents, scientific reports and marketing collateral."
      />
      <WhatsAppComp
        fHead="Looking"
        secondHead=" for a technical language translator?"
        content="If you're looking for a technical translator, your best bet is Tomedes. We offer 24/7 support from translators and
        project managers alike. We also offer a full one year guarantee on all translation services. A technical translator is
        just a call away at Tomedes, so call today."
        btn
      />
      <TrustedTranslation
        backgroundCol="bg-midBlue"
        FirstWhite="Our"
        headColor="text-orange"
        ColorHead="Network"
        SecondWhite="of expert technical translators"
        Content="The Tomedes global team of technical translators runs the gamut of languages, mastering more than 120 tongues. In addition to this broad linguistic coverage, there is tremendous diversity in the professional training of our translation specialists in terms of the scholarly disciplines and professional experience they bring to each project. Whether it is scientific, mathematical, or engineering expertise that you require, Tomedes can set you up with a language specialist familiar with the insider terminology of your domain, assuring excellence in technical translation."
      />

      <CommonUseCases
        backgroundCol="bg-darkBlue"
        firstTitle="Common Use "
        midTitle="Cases"
        midCol="text-lightBlue"
      />
      <SpeceficTranslation
        backgroundCol="bg-midBlue"
        FirstWhite="Translate Your"
        SecondWhite=" Documents in Over 120 Languages and 950+ Language Pairs"
        headColor="text-orange"
        colorHead="Technical"
        Content="Your technical documents will be translated in languages such as Japanese, French, Spanish, and Russian, among others, in our selection of over 120 languages and 950+ language pairs. Your documents will be translated by a native language translator, ensuring accuracy and quality with every word."
        backgroundCol="bg-midBlue"
        getStarted
        link
        getStartedLink="/language-translation-service.php"
      />
      <WhatChooseUs backgroundCol="bg-darkBlue" />
      <Reviews backgroundCol="bg-midBlue" />
    </>
  );
}

export default TechnicalTranslation;
